<template>
  <div>
    <!-- MODO NORMAL: exibe seletor de mês + botão Executar -->
    <div v-if="!printMode">
      <h6>Alunos Aniversariantes</h6><p></p>
      <div class="row align-items-end mb-3">
        <div class="col-auto">
          <label for="mes">Mês:</label>
          <select
            id="mes"
            v-model="mesSelecionadoLocal"
            class="form-control select-mes"
          >
            <option
              v-for="m in meses"
              :key="m.value"
              :value="m.value"
            >
              {{ m.label }}
            </option>
          </select>
        </div>
        <div class="col-auto">
          <button @click="abrirPrint" class="btn btn-primary">Executar</button>
        </div>
      </div>
      <!-- Exibição do nome do mês selecionado -->
      <!-- <h6>Mês selecionado: {{ nomeMes }}</h6> -->
    </div>

    <!-- MODO IMPRESSÃO: busca dados no backend e exibe tabela -->
    <div v-else>
      <div v-if="loading">Carregando…</div>
      <div v-else-if="!loading && resultados.length">
      <p class="text-center" style="font-size: 16px">
        Mês de {{ nomeMes }}
      </p>

        <table class="table table-striped">
          <thead>
            <tr>
              <th>Id</th>
              <th>None</th>
              <th class="text-center">Data de Nasccimento</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="aluno in resultados" :key="aluno.id">
              <td>{{ aluno.id }}</td>
              <td>{{ aluno.nome }}</td>
              <td class="text-center">{{ formatarData(aluno.data_nascimento) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else-if="!loading && executed">
        <p>Nenhum aniversariante encontrado para este mês.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'

// Props vindos da rota de impressão
const props = defineProps({
  printMode:  { type: Boolean, default: false },
  mes:        { type: [String, Number], default: null },
  printTitle: { type: String, default: 'Alunos Aniversariantes' },
  subtitle:   { type: String, default: '' }
})

const router = useRouter()

// --- Estado para dropdown de meses ---
const meses = [
  { value: 1,  label: 'Janeiro'   },
  { value: 2,  label: 'Fevereiro' },
  { value: 3,  label: 'Março'     },
  { value: 4,  label: 'Abril'     },
  { value: 5,  label: 'Maio'      },
  { value: 6,  label: 'Junho'     },
  { value: 7,  label: 'Julho'     },
  { value: 8,  label: 'Agosto'    },
  { value: 9,  label: 'Setembro'  },
  { value: 10, label: 'Outubro'   },
  { value: 11, label: 'Novembro'  },
  { value: 12, label: 'Dezembro'  }
]
const mesSelecionadoLocal = ref(new Date().getMonth() + 1) // default para mês atual

// --- Estados compartilhados ---
const loading    = ref(false)
const resultados = ref([])
const executed   = ref(false)

// Computed para retornar sempre o “valor numérico do mês” correto
const mesAtivo = computed(() => {
  // Se estivermos em modo impressão, usamos props.mes (que vem como string ou número)
  if (props.printMode) {
    return Number(props.mes)
  }
  // Caso contrário (modo normal), usamos a seleção local
  return Number(mesSelecionadoLocal.value)
})

// Computed para traduzir o número do mês em label
const nomeMes = computed(() => {
  const achado = meses.find(m => m.value === mesAtivo.value)
  return achado ? achado.label : ''
})

// Função para buscar aniversariantes do mês
async function buscarAniversariantes(mesParam) {
  if (!mesParam) return
  loading.value    = true
  executed.value   = false
  resultados.value = []

  try {
    const res = await axios.get('/gestao/relatorios/cadastrais/alunos-aniversariantes', {
      params: { mes: mesParam }
    })
    resultados.value = Array.isArray(res.data) ? res.data : []
  } catch (err) {
    console.error('Erro ao buscar aniversariantes:', err)
    resultados.value = []
  } finally {
    loading.value  = false
    executed.value = true
  }
}

// Ao montar, decide se está em modo impressão ou não
onMounted(() => {
  if (!props.printMode) {
    // Apenas monta a tela normal – não faz busca automática
    return
  }

  // MODO IMPRESSÃO: chama diretamente com o mês vindo pelas props
  buscarAniversariantes(mesAtivo.value)
})

// Função chamada no modo normal para redirecionar à rota de impressão
function abrirPrint() {
  if (!mesSelecionadoLocal.value) return

  const textoSubtitle = `Mês de ${nomeMes.value}`

  router.push({
    path: `/gestao/relatorios/print/alunos-aniversariantes`,
    query: {
      title: props.printTitle,
      mes:   mesSelecionadoLocal.value,
      subtitle: textoSubtitle
    }
  })
}

// Utilitário para formatar datas
function formatarData(dateStr) {
  if (!dateStr) return ''
  const d   = new Date(dateStr)
  const dia = String(d.getDate()).padStart(2, '0')
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const ano = d.getFullYear()
  return `${dia}/${mes}/${ano}`
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.select-mes {
  min-width: 8rem;   /* ou ajuste para 10rem, 120px, etc */
}

</style>
